import React from 'react';
import './SandboxNote.scss';

/* Says something about a screen that shows a sandbox, in the look of the banner above it but inside the page, next to what it is about. */
export const SandboxNote = ({ children, className }) => (
    <div className={'sandbox-note' + (className ? ` ${className}` : '')}>
        <i className={'material-icons'}>science</i>
        <span>{children}</span>
    </div>
);
